export default __webpack_public_path__ + "static/media/thirdBackGround.ec8c32d0.png";